import { keepPreviousData } from '@tanstack/react-query';

import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getEvents } from '../api/services/Events';
import { EventListItem, EventsQueryParams } from '../types/events';

interface IUserEventsQuery {
  rideSlug: string;
  queryParams: EventsQueryParams;
}

export const useEventsQuery = ({ rideSlug, queryParams }: IUserEventsQuery) => {
  return useApiGet<{ data: EventListItem[]; meta: Meta }>(
    ['eventsList', rideSlug, queryParams.page],
    () => getEvents(rideSlug, queryParams),
    {
      enabled: true,
      mutationKey: 'page',
      placeholderData: keepPreviousData,
    }
  );
};
